import React from "react";
import { graphql, PageProps } from "gatsby";

import { SEO } from "../components/common/seo";
import { VenueDirectory } from "../components/Pages/VenueDirectory";
import { VenueDataFragment } from "../components/Pages/Venue";

interface VenueDirectoryProps {
  data: {
    frontmatter: {
      content: string;
    };
  };
  allMarkdownRemark: {
    edges: Array<{
      node: {
        frontmatter: Pick<
          VenueDataFragment,
          "image" | "name" | "status" | "description" | "tags" | "location"
        >;
        fields: {
          slug: string;
        };
      };
    }>;
  };
}

const VenueDirectoryPage: React.FC<PageProps<VenueDirectoryProps>> = ({
  data,
}) => {
  return (
    <>
      <SEO title="Venues" />

      <VenueDirectory
        items={data.allMarkdownRemark.edges.map(({ node }) => ({
          ...node.frontmatter,
          slug: node.fields.slug,
        }))}
        content={data.data.frontmatter.content}
      />
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default VenueDirectoryPage;

export const query = graphql`
  query VenueDirectoryQuery {
    data: markdownRemark(fileAbsolutePath: { regex: "/venues.md/" }) {
      frontmatter {
        content
      }
    }
    allMarkdownRemark(
      sort: { order: ASC, fields: fields___slug }
      filter: { fields: { sourceName: { eq: "venues" } } }
    ) {
      edges {
        node {
          frontmatter {
            image {
              publicURL
            }
            name
            status
            description
            tags
            location
          }
          fields {
            slug
          }
        }
      }
    }
  }
`;
